import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ScrollBar from "components/ScrollBar";
import Spaceviewer, { SpaceviewerAppearance } from "rs-components/Spaceviewer";
import { DEFAULT_TARGET } from "../..";
import { clearPreviewRequest, getOptimizationPreview, resetOptimizationPreview, setOptimizationPreviewAxis, } from "store/rs-workspace/actions/rs-workspace.actions";
import { CancelOutdatedPreviewType } from "store/rs-workspace/rs-workspace.types";
import { fetchingCurrentOptimizationPreviewDataSelector, oldInsightValueForOptimizationSelector, oldOptimizationValuesSelector, optimizationDialogOpenSelector, optimizationPreviewDataSelector, optimizationPreviewInsightErrorSelector, } from "store/rs-workspace/selectors/rs-workspace.selectors";
import { compareParametersToOptimize } from "store/rs-workspace/utils/scenario.utils";
import { isOptimizationPreviewCanBeCalculated } from "store/rs-workspace/utils/completeness.utils";
import { filteredOptimizationParametersToCalculateSelector } from "store/rs-workspace/selectors/rs-workspace.selectors";
import * as styles from "./styles.module.scss";
const OptimizationPreview = ({ optimizationId, isCompleted, optimizationState, isVisible }) => {
    const dispatch = useDispatch();
    const fetchingOptimizationPreviewData = useSelector(fetchingCurrentOptimizationPreviewDataSelector);
    const optimizationDialogOpen = useSelector(optimizationDialogOpenSelector);
    const insight = useSelector(oldInsightValueForOptimizationSelector(optimizationState?.input));
    const parameters = useSelector(oldOptimizationValuesSelector(optimizationState));
    const insightError = useSelector(optimizationPreviewInsightErrorSelector);
    const filteredOptimizationParametersToCalculate = useSelector(filteredOptimizationParametersToCalculateSelector(optimizationState));
    const { requestedParameters, selectedAxisIndexes, data, errorMessage } = useSelector(optimizationPreviewDataSelector(optimizationState?.parameters ?? [], optimizationState?.input?.optimizationTarget ?? DEFAULT_TARGET, optimizationState?.input?.insightId, optimizationState?.input?.insightInputSetId, Boolean(isCompleted)));
    const changeSelectedAxisIndexes = useCallback((indexes) => {
        dispatch(setOptimizationPreviewAxis(indexes));
    }, [dispatch]);
    useEffect(() => {
        if (!isVisible || !optimizationDialogOpen) {
            return;
        }
        const preparedOptimizationState = {
            ...optimizationState,
            parameters: filteredOptimizationParametersToCalculate,
        };
        if (isOptimizationPreviewCanBeCalculated(preparedOptimizationState)) {
            if (isCompleted &&
                !compareParametersToOptimize(requestedParameters, preparedOptimizationState?.parameters)) {
                dispatch(getOptimizationPreview({ elementId: optimizationId ?? -1, request: preparedOptimizationState }));
            }
        }
        else if (data.values.length > 0) {
            dispatch(resetOptimizationPreview(optimizationId ?? -1));
            dispatch(clearPreviewRequest({
                previewType: CancelOutdatedPreviewType.Optimization,
                elementId: optimizationId ?? -1,
            }));
        }
    }, [
        data.values.length,
        dispatch,
        filteredOptimizationParametersToCalculate,
        isCompleted,
        isVisible,
        optimizationDialogOpen,
        optimizationId,
        optimizationState,
        requestedParameters,
    ]);
    return (React.createElement("div", { className: styles.root },
        React.createElement(ScrollBar, null,
            React.createElement("div", { className: styles["optimization-preview"] },
                React.createElement(Spaceviewer, { data: data, error: errorMessage ?? "", selectedAxisIndexes: selectedAxisIndexes, appearance: SpaceviewerAppearance.OptimizationPreview, changeSelectedAxisIndexes: changeSelectedAxisIndexes, legendData: { insight, parameters: parameters }, insightError: insightError, inProgress: fetchingOptimizationPreviewData, recalculateWidth: isVisible })))));
};
export default OptimizationPreview;
